import { styled } from '@linaria/react';

export const BackIcon = styled.div`
  position: relative;
  width: 6px;
  height: 13px;
  transform: rotate(180deg);

  &::before,
  &::after {
    content: '';
    position: absolute;
    width: 9px;
    height: 2px;
    background-color: #ccc;
    border-radius: 1px;
  }

  &::before {
    top: 0;
    left: 0;
    transform-origin: top left;
    transform: rotate(45deg);
  }

  &::after {
    bottom: 0;
    left: 0;
    transform-origin: bottom left;
    transform: rotate(-45deg);
  }
`;
